import { ShiftManagementTemplateWeeksDocument } from 'generated/resources/graphql'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

import { useTemplateWeeks } from 'modules/shift_management/hooks/useTemplateWeeks'
import TemplateWeeks from 'modules/shift_management/store/internal/collections/TemplateWeeks'

const useFetchTemplateWeeks = () => {
  const [, dispatchTemplateWeeks] = useTemplateWeeks()

  const { loading, data } = useQuery(ShiftManagementTemplateWeeksDocument, {})

  const templateWeeks: TemplateWeeks = useUnsafeMemo(
    () => TemplateWeeks.buildFromGraphQL(data?.shiftManagement?.templateWeeks || []),
    [data?.shiftManagement.templateWeeks]
  )

  useUnsafeEffect(() => {
    if (!loading) dispatchTemplateWeeks({ type: 'BOOTSTRAP', templateWeeks })
  }, [dispatchTemplateWeeks, loading, templateWeeks])

  return { templateWeeks, loading }
}

export default useFetchTemplateWeeks
